<template>
  <div class="hom">
    <title>微云腾|企业建站|logo设计|网站维护|平面设计|网站推广</title>
    <meta name="keywords" content="深圳市微云腾科技有限公司,专业建站,模板定制建站,全定制建站,logo设计,平面设计">
    <!-- 首页头部 -->
    <div class="head">
      <div class="hnav">
        <div class="contaniner">
          <div class="hn">
            <Navbar></Navbar>
          </div>
        </div>
      </div>
      <div class="lunbo">
        <el-carousel indicator-position="outside">
          <el-carousel-item v-for="(item,i) in banners" :key="i">
            <img :src="item" alt="微云腾轮播图" />
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>
    <!-- 核心服务 -->
    <div class="server">
      <img src="../assets/img/1.jpg" alt class="yy" />
      <div class="bgc"></div>
      <div class="bigbox">
        <div class="contaniner">
          <div class="fuwu">
            <p style="color:#24C0EA; text-align: center;font-size:30px;">微 云 腾 核 心 服 务</p>
            <br />
            <p style="text-align: center;color:#BBBBBB;">万家中国外贸电商企业信赖的全球SDWAN网络专线以及网站平台建设者，2024, 不断创新</p>
          </div>
          <ul class="neirong">
            <li>
              <img src="../assets/img/wzjs.png" alt />
              <p>企业网站建设</p>
              <br />
              <p style="font-size:14px; color:#666666;">
                品牌网站创意设计
                <br />企业集团网站建设
                <br />活动专题创意设计
                <br />电商/门户网站建设
              </p>
            </li>
            <li>
              <img src="../assets/img/wzwh.png" alt />
              <p>全球服务器租用</p>
              <br />
              <p style="font-size:14px; color:#666666;">
                7*24H售后服务
                <br />一手服务器资源
                <br />免费增值服务
                <br />IDC八年经验
              </p>
            </li>
            <li>
              <img src="../assets/img/pmsj.png" alt />
              <p>SDWAN跨境专线</p>
              <br />
              <p style="font-size:14px; color:#666666;">
                全球200+节点
                <br />本地干净IP
                <br />互联网平台管控
                <br />1对1售后服务
              </p>
            </li>
            <li>
              <img src="../assets/img/jmsj.png" alt />
              <p>SDWNAN跨境组网</p>
              <br />
              <p style="font-size:14px; color:#666666;">
                海外资源节点丰富
                <br />全程数据加密
                <br />接入简便快速
                <br />上门提供安装
              </p>
            </li>
          </ul>
          <div class="more">
            <router-link to="/product">More</router-link>
          </div>
        </div>
      </div>
    </div>

    <!-- 案例展示 -->
    <div class="share">
      <img src="../assets/img/qyal.png" alt class="alyy" />
      <div class="albgc"></div>
      <div class="top">
        <div class="contaniner">
          <div class="alzs">
            <p style="color:#24C0EA; text-align: center;font-size:30px;">前 沿 案 例 展 示</p>
            <br />
            <p style="text-align: center;color:#BBBBBB;">以策略设计技术服务为核心，为客户持续创造价值</p>
          </div>
          <div class="zwm">
            <el-tabs v-model="activeName" @tab-click="handleClick">
              <el-tab-pane label="网站建设" name="first">
                <div class="wz">
                  <div class="zuo"><img src="../assets/syalt/1.gif" alt="" class="f"></div>
                  <ul class="you">
                    <li><img src="../assets/syalt/2.gif" alt=""></li>
                    <li><img src="../assets/syalt/3.gif" alt=""></li>
                    <li><img src="../assets/syalt/4.gif" alt=""></li>
                    <li><img src="../assets/syalt/5.gif" alt=""></li>
                    <li><img src="../assets/syalt/6.gif" alt=""></li>
                    <li><img src="../assets/syalt/7.gif" alt=""></li>
                  </ul>
                </div>
              </el-tab-pane>
              <el-tab-pane label="全球服务器租用" name="second">
                <div class="wz">
                  <div class="zuo"><img src="../assets/syalt/1.gif" alt="" class="f"></div>
                  <ul class="you">
                    <li><img src="../assets/syalt/2.gif" alt=""></li>
                    <li><img src="../assets/syalt/3.gif" alt=""></li>
                    <li><img src="../assets/syalt/4.gif" alt=""></li>
                    <li><img src="../assets/syalt/5.gif" alt=""></li>
                    <li><img src="../assets/syalt/6.gif" alt=""></li>
                    <li><img src="../assets/syalt/7.gif" alt=""></li>
                  </ul>
                </div>
              </el-tab-pane>
              <el-tab-pane label="SDWAN跨境专线" name="third">
                <div class="wz">
                  <div class="zuo"><img src="../assets/syalt/1.gif" alt="" class="f"></div>
                  <ul class="you">
                    <li><img src="../assets/syalt/2.gif" alt=""></li>
                    <li><img src="../assets/syalt/3.gif" alt=""></li>
                    <li><img src="../assets/syalt/4.gif" alt=""></li>
                    <li><img src="../assets/syalt/5.gif" alt=""></li>
                    <li><img src="../assets/syalt/6.gif" alt=""></li>
                    <li><img src="../assets/syalt/7.gif" alt=""></li>
                  </ul>
                </div>
              </el-tab-pane>
              <el-tab-pane label="SDWNAN跨境组网" name="fourth">
                <div class="wz">
                  <div class="zuo"><img src="../assets/syalt/1.gif" alt="" class="f"></div>
                  <ul class="you">
                    <li><img src="../assets/syalt/2.gif" alt=""></li>
                    <li><img src="../assets/syalt/3.gif" alt=""></li>
                    <li><img src="../assets/syalt/4.gif" alt=""></li>
                    <li><img src="../assets/syalt/5.gif" alt=""></li>
                    <li><img src="../assets/syalt/6.gif" alt=""></li>
                    <li><img src="../assets/syalt/7.gif" alt=""></li>
                  </ul>
                </div>
              </el-tab-pane>
            </el-tabs>
          </div>
          <div class="more2">
            <router-link to="/share">More</router-link>
          </div>
        </div>
      </div>
    </div>
    <!-- 资讯中心 -->
    <div class="zixun">
      <img src="../assets/img/zxzx.jpg" alt class="zxyy" />
      <div class="zxbgc"></div>
      <div class="zxbig">
        <div class="contaniner">
          <div class="zxzx">
            <p style="color:#24C0EA; text-align: center;font-size:30px;">资 讯 中 心</p>
            <br />
            <p style="text-align: center;color:#BBBBBB;">适合自己的，才是最好的，我们始终坚信，优秀的企业形象是企业的一笔重要的财富！</p>
          </div>
          <div class="zxnr">
            <ul class="nr">
              <li>
                <img src="../assets/xwxt/1.png" alt="新闻缩略图">
                <span>
                  <router-link to="/newnr">企业标志LOGO设计有哪些事项是需要忌讳和注意的</router-link>
                  <p>靠前：一个企业的标志设计中不应参杂进宗教和文化禁忌的符号元素进来比如，纳粹、异教等被全世界人民所痛恨的禁忌元素...</p>
                  <p>2020-04-26</p>
                </span>
              </li>
              <li><img src="../assets/xwxt/1.png" alt="">
                <span>
                  <router-link to="/newnr">企业标志LOGO设计有哪些事项是需要忌讳和注意的</router-link>
                  <p>靠前：一个企业的标志设计中不应参杂进宗教和文化禁忌的符号元素进来比如，纳粹、异教等被全世界人民所痛恨的禁忌元素...</p>
                  <p>2020-04-26</p>
                </span>
              </li>
              <li><img src="../assets/xwxt/1.png" alt="">
                <span>
                  <router-link to="/newnr">企业标志LOGO设计有哪些事项是需要忌讳和注意的</router-link>
                  <p>靠前：一个企业的标志设计中不应参杂进宗教和文化禁忌的符号元素进来比如，纳粹、异教等被全世界人民所痛恨的禁忌元素...</p>
                  <p>2020-04-26</p>
                </span>
              </li>
              <li><img src="../assets/xwxt/1.png" alt="">
                <span>
                  <router-link to="/newnr">企业标志LOGO设计有哪些事项是需要忌讳和注意的</router-link>
                  <p>靠前：一个企业的标志设计中不应参杂进宗教和文化禁忌的符号元素进来比如，纳粹、异教等被全世界人民所痛恨的禁忌元素...</p>
                  <p>2020-04-26</p>
                </span>
              </li>
            </ul>
          </div>
          <div class="zxmore">
            <router-link to="/newnr">More</router-link>
          </div>
        </div>
      </div>
    </div>
    <div class="foot">
        <Footer></Footer>
    </div>
  </div>
</template>

<style lang="scss" scope>
* {
  padding: 0;
  margin: 0;
}
.hom {
  .head {
    width: 100%;
    height: 800px;
    position: relative;
    .hnav {
      z-index: 3;
      position: absolute;
      top: 0;
      left: 50%;
      margin-left: -600px;
      .hn{
        width: 100%;
        height: 70px;
      }
    }
    .lunbo {
      height: 800px;
    }
  }
  .contaniner {
    width: 1200px;
    margin: 0 auto;
  }
  // 服务
  .server {
    width: 100%;
    height: 836px;
    position: relative;
    .yy {
      width: 100%;
      height: 836px;
      filter: blur(5px);
    }
    .bgc {
      width: 100%;
      height: 836px;
      background-color: #000;
      opacity: 0.75;
      position: absolute;
      top: 0;
    }
    .bigbox {
      width: 100%;
      height: 836px;
      position: absolute;
      top: 0;
    }
    .fuwu {
      width: 100%;
      height: 100px;
      margin-top: 80px;
      z-index: 5;
      text-align: center;
    }
    .neirong {
      width: 100%;
      height: 400px;
      list-style: none;
      margin: 0 auto;
      z-index: 5;
      margin-top: 65px;
      margin-bottom: 85px;
      li {
        width: 15%;
        text-align: center;
        float: left;
        padding-left: 60px;
        padding-right: 60px;
        height: 350px;
        img {
          width: 60px;
          height: 60px;
          padding-bottom: 35px;
        }
        p {
          color: #bbbbbb;
          line-height: 45px;
        }
      }
    }
    .more {
      width: 30%;
      height: 60px;
      text-align: center;
      line-height: 50px;
      cursor: pointer;
      z-index: 5;
      border: 1px solid #666666;
      margin: 0 auto;
      a {
        display: block;
        width: 100%;
        height: 60px;
        color: #24c0ea !important;
        text-decoration: none;
      }
    }
    .more:hover{
      border: 1px solid #24c0ea;
    }
  }
  // 前沿案例
  .share {
    width: 100%;
    height: 1020px;
    position: relative;
    .alyy {
      width: 100%;
      height: 1020px;
      filter: blur(5px);
    }
    .albgc {
      width: 100%;
      height: 1020px;
      background-color: #000;
      opacity: 0.75;
      position: absolute;
      top: 0;
    }
    .top {
      width: 100%;
      height: 1020px;
      position: absolute;
      top: 0;
      }
      .alzs {
        width: 100%;
        height: 100px;
        margin-top: 65px;
        z-index: 5;
        text-align: center;
      }
      .zwm {
        width: 100%;
        // width: 800px;
        // height: 250px;
        margin: 0 auto;
        color: #BBBBBB;
        text-align: center;
        margin-top: 30px;
        margin-bottom: 83px;
        .wz{
          // width: 606px;
          width: 100%;
          // height: 210px;
          // margin: 0 auto;
          overflow: hidden;
          .zuo{
            // width: 200px;
            width: 40%;
            height: 540px;
            float: left;
            .f{
              width: 100%;
              height: 540px;
            }
          }
          .you{
            list-style: none;
            float: right;
            // width: 406px;
            width: 60%;
            height: 540px;
            li{
              float: left;
              width: 33.33333%;
              height: 270px;
              img{
                width: 100%;
                height: 100%;
              }
            }
          }
        }
      }
      .more2 {
      width: 30%;
      height: 60px;
      text-align: center;
      line-height: 50px;
      cursor: pointer;
      z-index: 5;
      border: 1px solid #666666;
      margin: 0 auto;
      a {
        display: block;
        width: 100%;
        height: 60px;
        color: #24c0ea !important;
        text-decoration: none;
      }
    }
    .more2:hover{
      border: 1px solid #24c0ea;
    }
    
    
  }
  // 资讯中心
  .zixun {
    width: 100%;
    height: 888px;
    position: relative;
    .zxyy {
      width: 100%;
      height: 888px;
      filter: blur(5px);
    }
    .zxbgc {
      width: 100%;
      height: 888px;
      background-color: #000;
      opacity: 0.75;
      position: absolute;
      top: 0;
    }
    .zxbig {
      width: 100%;
      position: absolute;
      top: 0;
      .zxzx {
      width: 100%;
      height: 100px;
      margin-top: 85px;
      z-index: 5;
      text-align: center;
    }
    .zxnr{
      width: 100%;
      height: 400px;
      margin-top: 85px;
      margin-bottom: 60px;
      .nr{
        width: 100%;
        height: 400px;
        list-style: none;
        li:hover a{
          color: #24c0ea;
        }
        li{
          width: 47.5%;
          padding-left: 30px;
          padding-bottom: 60px;
          cursor: pointer;
          height: 120px;
          float: left;
          img{
            width: 19.166%;
            height: 120px;
          }
          span{
            display: block;
            width: 70.83333%;
            height: 120px;
            float:right;
            a{
              color: #666666;
              text-decoration: none;
              line-height: 40px;
              font-size: 16px;
            }
            a:hover{
              color: #24c0ea;
            }
            p{
              color: #BBBBBB;
              font-size: 14px;
            }
          }
        }
      }
    }
    }
    .zxmore {
      width: 30%;
      height: 60px;
      text-align: center;
      line-height: 50px;
      cursor: pointer;
      z-index: 5;
      border: 1px solid #666666;
      margin: 0 auto;
      a {
        display: block;
        width: 100%;
        height: 60px;
        color: #24c0ea !important;
        text-decoration: none;
      }
    }
    .zxmore:hover{
      border: 1px solid #24c0ea;
    }
  }
}
@media screen and (max-width:480px){
  .contaniner{
    width: calc( 100% - 30px ) !important;
    padding-left: 15px;
    padding-right: 15px;
  }
  .lunbo{
    width: 100% !important;
    height: 174px !important;
    img{
      height: auto !important;
    }
  }
  .hnav{
    width: calc( 100% - 30px ) !important;
    padding-left: 15px;
    padding-right: 15px;
    margin-left: -200px !important;
  }
}
</style>
<style lang="scss">
.el-carousel__indicators {
  position: absolute !important;
  bottom: 0;
}
.el-carousel__item{
  img{
    width: 100%;
    height: 100%;
  }
}
.el-carousel {
  // height: 400px;
}
.el-carousel__container {
  height: 800px !important;
}
.el-tabs__item.is-active{
    color: #409EFF !important;
  }
.el-tabs__item{
  width: 7.894737%;
  color: #BBBBBB !important;
  padding: 0 !important;
  margin: 0 50px ;
  font-size: 18px;
}
// 去掉底下白线的
.el-tabs__nav-wrap::after{
  display: none !important;

}
// 去掉底下蓝线的
.el-tabs__active-bar{
  display: none !important;
}
#tab-first{
  margin-left: 300px;
}
// 四个tab的下边距
.el-tabs__header{
  margin-bottom: 60px !important;
}
</style>

<script>
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
export default {
  data() {
    return {
      banners: [
        require("../assets/img/2.jpg"),
        require("../assets/img/2.jpg"),
        require("../assets/img/1.jpg"),
        require("../assets/img/1.jpg")
      ],
      activeName: "first"
    };
  },
  methods: {
    handleClick(tab, event) {
      console.log(tab, event);
    }
  },
  components: {
    Navbar,
    Footer
  }
};
</script>

